/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import Papa from "papaparse";
import { Line, Bar, Doughnut, Pie } from "react-chartjs-2";
import { CsvToHtmlTable } from "react-csv-to-table";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      intro: true,
      uploaded: false,
      csvfile: null,
      csvcontent: "",
      csvdata: [],
      charttype: "Line",
      chartdata: null,
      toggleTable: false,
      colors: [
        "#36a2eb",
        "#809bf6",
        "#c08ef",
        "#f47ed6",
        "#ff72ae",
        "#ff767d",
        "#ff8a4a",
        "#ffa600"
      ]
    };
  }

  changeIntro() {
    this.setState({ intro: false });
  }

  renderIntro() {
    return (
      <div>
        <div className="intro-header">
          <img src="./monitor.png" alt="logo" />
          <h1>EasyChart</h1>
          <h3>Create and download charts and graphs on your browser</h3>
        </div>

        <div className="intro-header-button">
          <button
            className="pure-button pure-button-primary button-xlarge"
            onClick={() => this.changeIntro()}>
            Get Started!
          </button>
        </div>
      </div>
    );
  }

  handleChange(event) {
    Papa.parse(event.target.files[0], {
      complete: e => this.updateData(e)
    });
  }

  makeChartData(csvdata) {
    const labels = [];
    const datasets = [];
    let maxlength = 0;

    for (let i = 1; i < csvdata.length; i++) {
      if (csvdata[i].length > 0) {
        labels.push(csvdata[i][0]);
      }

      if (csvdata[i].length > maxlength) {
        maxlength = csvdata[i].length;
      }
    }

    for (let i = 1; i < maxlength; i++) {
      const temp = [];
      for (let j = 1; j < csvdata.length; j++) {
        if (csvdata[j][i]) {
          temp.push(csvdata[j][i]);
        } else {
          temp.push(0);
        }
      }
      datasets.push({
        data: temp,
        label: csvdata[0][i],
        backgroundColor: this.state.colors[i - 1]
          ? this.state.colors[i - 1]
          : "blue",
        borderColor: this.state.colors[i - 1]
          ? this.state.colors[i - 1]
          : "blue",
        fill: false
      });
    }

    this.setState({ chartdata: { labels, datasets } });
  }

  updateData(result) {
    const data = result.data;
    const unparsedData = Papa.unparse(data);
    this.setState({ csvcontent: unparsedData, csvdata: data });
    this.makeChartData(data);
  }

  updateCSVData(e) {
    Papa.parse(e.target.value, {
      complete: e => this.updateData(e)
    });
  }

  changeChartType(e) {
    this.setState({ charttype: e.target.value });
  }

  showChart() {
    this.setState({ showChart: true, uploaded: true });
  }

  togglePreview() {
    const toggleTable = this.state.toggleTable;
    if (toggleTable) {
      this.setState({ toggleTable: false });
    } else {
      this.setState({ toggleTable: true });
    }
  }

  renderUpload() {
    return (
      <div>
        <div className="upload-header">
          <h1>EasyChart</h1>
          <h3>Upload a CSV or paste CSV contents</h3>
        </div>

        <div className="intro-header-button">
          <div className="upload-btn-wrapper">
            <button className="pure-button pure-button-primary button-xlarge">
              Upload a CSV
            </button>
            <input
              type="file"
              ref={input => {
                this.filesInput = input;
              }}
              name="file"
              placeholder={null}
              onChange={e => this.handleChange(e)}
            />
          </div>

          <div className="csv-content">
            <textarea
              className="textarea"
              placeholder="Paste CSV content"
              rows="15"
              value={this.state.csvcontent}
              onChange={e => this.updateCSVData(e)}
            />
          </div>

          <div className="chart-choice">
            <label htmlFor="chartchoice">Choose Chart Type</label>
            <br />
            <select
              id="chartchoice"
              value={this.state.charttype}
              onChange={e => this.changeChartType(e)}>
              <option>Line</option>
              <option>Bar</option>
              <option>Doughnut</option>
              <option>Pie</option>
            </select>
          </div>

          <div>
            <a
              href="#"
              onClick={e => {
                e.preventDefault();
                this.togglePreview();
              }}>
              {this.state.toggleTable
                ? "Hide Data Preview"
                : "Show Data Preview"}
            </a>

            {this.state.toggleTable ? (
              <CsvToHtmlTable
                data={this.state.csvcontent}
                csvDelimiter=","
                tableClassName="pure-table pure-table-bordered"
              />
            ) : null}
          </div>

          <button
            className="pure-button button-success button-xlarge"
            onClick={() => this.showChart()}
            disabled={this.state.chartdata ? "" : "1"}>
            Generate Chart
          </button>
        </div>
      </div>
    );
  }

  modifyChartData(chartdata) {
    const labels = chartdata.labels;
    const datasets = [];

    chartdata.datasets.forEach(val => {
      datasets.push({
        data: val.data,
        backgroundColor: this.state.colors,
        hoverBackgroundColor: this.state.colors
      });
    });
    return { labels, datasets };
  }

  sendChart() {
    const { charttype, chartdata } = this.state;
    if (charttype === "Line") {
      return <Line data={chartdata} />;
    } else if (charttype === "Bar") {
      return <Bar data={chartdata} />;
    } else if (charttype === "Doughnut") {
      const newdata = this.modifyChartData(chartdata);
      return <Doughnut data={newdata} />;
    } else if (charttype === "Pie") {
      const newdata = this.modifyChartData(chartdata);
      return <Pie data={newdata} />;
    }
  }

  downloadChart() {
    var url_base64jp = document
      .getElementsByTagName("canvas")[0]
      .toDataURL("image/jpg");
    var a = document.getElementById("download");
    a.href = url_base64jp;
  }

  renderChart() {
    return (
      <div>
        <div className="upload-header">
          <h1>EasyChart</h1>
          <h3>View and download your chart</h3>
        </div>

        <div className="intro-header-button">
          <div className="chart-choice">
            <label htmlFor="chartchoice">Choose Chart Type</label>
            <br />
            <select
              id="chartchoice"
              value={this.state.charttype}
              onChange={e => this.changeChartType(e)}>
              <option>Line</option>
              <option>Bar</option>
              <option>Doughnut</option>
              <option>Pie</option>
            </select>
          </div>

          <div id="chart">{this.sendChart()}</div>

          <a
            id="download"
            className="pure-button button-success button-xlarge"
            onClick={() => this.downloadChart()}
            download="ChartImage.jpg"
            href=""
            value="Download Chart">
            Download Chart
          </a>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.intro ? this.renderIntro() : null}

        {!this.state.intro && !this.state.uploaded ? this.renderUpload() : null}

        {this.state.uploaded && this.state.showChart
          ? this.renderChart()
          : null}

        <div
          style={{
            marginTop: 30,
            position: "relative",
            bottom: 0
          }}>
          <center>
            <p>
              Made with <span style={{ color: "#e25555" }}>&#9829;</span> by{" "}
              <a href="https://twitter.com/jyotiska_nk">@jyotiska</a>
            </p>
          </center>
        </div>
      </div>
    );
  }
}

export default App;
